import { gql, TypedDocumentNode } from '@apollo/client';

import { useSubscription } from '../useSubscription';

const OnDocumentsUpdatedOperationName = 'OnDocumentsUpdated';

const documentsUpdatedQuery: TypedDocumentNode<
  { documentsUpdated: string },
  { fileId: string }
> = gql`
  subscription OnDocumentsUpdated($fileId: UUID!) {
    documentsUpdated(fileId: $fileId) {
      updatedAt
    }
  }
`;

const useDocumentSubscription = ({
  onRefetchFileDocuments,
  fileSummary,
}: {
  onRefetchFileDocuments: () => void;
  fileSummary: { fileId: string };
}) => {
  const { fileId } = fileSummary;

  useSubscription({
    query: documentsUpdatedQuery,
    variables: { fileId },
    onNext: onRefetchFileDocuments,
    operationName: OnDocumentsUpdatedOperationName,
  });
};

export default useDocumentSubscription;
